var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:{ 'icon-spin': _vm.spin }},'svg',_vm.attrs,false),_vm.listeners),[(_vm.title !== '')?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }